import React, { useState, useEffect } from "react";
import { postData } from "../api/protectedApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLayout from "../component/dashboard/TransactionLayout";
import { handleExportData } from "../utils/exportUtils";
import { callDataByEndpoint } from "../utils/dataUtils";
import styles from "../component/dashboard/css/transaction.module.css";

const MarginTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const limit = 10;

  const callData = (page) => {
    callDataByEndpoint("/user/margin_transactions", {
      page,
      limit,
      setData: setTransactions,
      setTotalCount,
      setIsLoading,
    });
  };

  useEffect(() => {
    callData(currentPage);
  }, [currentPage]);

  const handleExport = (type) => {
    handleExportData({
      endpoint: "/user/margin_transactions",
      columns,
      fallbackData: transactions,
      filename: "margin_transactions",
      type,
      postDataFn: postData,
      toastFn: toast,
    });
  };

  const filteredTransactions = transactions.filter((t) => {
    const q = searchQuery.toLowerCase();
    return (
      (t.apiKey && t.apiKey.toLowerCase().includes(q)) ||
      (t.remark && t.remark.toLowerCase().includes(q)) ||
      (t.amount && t.amount.toString().includes(q))
    );
  });

  const columns = [
    { key: "id", label: "ID" },
    { key: "amount", label: "Amount" },
    { key: "commision", label: "Commision" },
    { key: "charge", label: "Charge" },
    { key: "payable", label: "Payable" },
    { key: "remark", label: "Remark" },
    { key: "apiKey", label: "ApiKey" },
    { key: "date", label: "Date" },
  ];

  return (
    <TransactionLayout
      title="Margin Transactions"
      subtitle="Audit account margin allocations, fee deductions, and net payable balances."
      searchQuery={searchQuery}
      onSearchChange={(q) => { setSearchQuery(q); setCurrentPage(1); }}
      searchPlaceholder="Search by API key, remark, or amount..."
      onExport={handleExport}
      cardTitle="Margin Ledger"
      cardSubtitle="Real-time margin settlement ledger"
      columns={columns}
      data={filteredTransactions}
      isLoading={isLoading}
      emptyMessage="No Margin Transactions Found."
      pagination={{
        currentPage,
        totalCount,
        limit,
        onPageChange: (page) => setCurrentPage(page),
      }}
    />
  );
};

export default MarginTransactions;
